import React from 'react'
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, /* Legend, */
} from 'recharts';
import { useViewport, viewportBreakpoint } from '../../../utils';

const ProgramChart = ({data}) => {
  const { width } = useViewport();
  const breakpoint = viewportBreakpoint.tablet;
  const isMobile = width < breakpoint;

  return (
    <ResponsiveContainer height={isMobile ? 195 : 300} width="100%">
      <LineChart
        data={data}
        // width={isMobile ? 295 : 800}
        // height={isMobile ? 195 : 300}
        // margin={{
        //   top: 5, right: 30, left: 20, bottom: 5,
        // }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        {/* <Legend /> */}
        <Line type="monotone" dataKey="pv" stroke="#52BAE2" fill="#52BAE2" activeDot={{ r: 10 }} />
      </LineChart>
    </ResponsiveContainer>
  )
}

export { ProgramChart }